export const rashiNakshatraMapping = {
  "rasi.aries": [
    "nakshatra.ashwini",
    "nakshatra.bharani",
    "nakshatra.krittika",
  ],
  "rasi.taurus": [
    "nakshatra.krittika",
    "nakshatra.rohini",
    "nakshatra.mrigashirsha",
  ],
  "rasi.gemini": [
    "nakshatra.mrigashirsha",
    "nakshatra.ardra",
    "nakshatra.punarvasu",
  ],
  "rasi.cancer": [
    "nakshatra.punarvasu",
    "nakshatra.pushya",
    "nakshatra.ashlesha",
  ],
  "rasi.leo": [
    "nakshatra.magha",
    "nakshatra.purvaPhalguni",
    "nakshatra.uttaraPhalguni",
  ],
  "rasi.virgo": [
    "nakshatra.uttaraPhalguni",
    "nakshatra.hasta",
    "nakshatra.chitra",
  ],
  "rasi.libra": ["nakshatra.chitra", "nakshatra.swati", "nakshatra.vishaka"],
  "rasi.scorpio": [
    "nakshatra.vishaka",
    "nakshatra.anuradha",
    "nakshatra.jyeshta",
  ],
  "rasi.sagittarius": [
    "nakshatra.moola",
    "nakshatra.purvaAshadha",
    "nakshatra.uttaraAshadah",
  ],
  "rasi.capricorn": [
    "nakshatra.uttaraAshadah",
    "nakshatra.shravana",
    "nakshatra.dhanistha",
  ],
  "rasi.aquarius": [
    "nakshatra.dhanistha",
    "nakshatra.shatabhisaak",
    "nakshatra.purvaBhadrapada",
  ],
  "rasi.pisces": [
    "nakshatra.purvaBhadrapada",
    "nakshatra.uttaraBhadrapada",
    "nakshatra.revati",
  ],
};
